<template>
	<div >
		<el-form :rules="rules" ref='loginForm' :model="LoginForm" class="loginContainer">
			<h3 class="loginTitle">系统登陆</h3>
			<el-form-item prop="username">
				<el-input type="text" v-model="LoginForm.username" autofocus="off" placeholder="请输入用户名"></el-input>
			</el-form-item>
			<el-form-item prop="password">
				<el-input type="password" v-model="LoginForm.password" autofocus="off" placeholder="请输入密码"
				 @keydown.enter.native="submitLogin"></el-input>
			</el-form-item>
			<div class="loginRemember">
			<el-checkbox size="normal"  v-model="checked"></el-checkbox>
			</div>
			<el-button type="primary" style="width: 100%;" @click="submitLogin">登陆</el-button>
		</el-form>
		<div style="text-align:center">
		<a href="https://beian.miit.gov.cn/">浙ICP备2022014311号-1</a>	
		<br/>
		© 2022 HACH Company.
		 保留所有权利。
		 </div>
	</div>
	
</template>

<script>
	//import {postKeyValueRequest} from "../utils/api.js"
	export default{
		name:"Login",		
		data(){
			return{
				LoginForm:{
					username:'',
					password:''
				},
				checked:true,
				rules:{
					username: [
							{ required: true, message: '请输入用户名！', trigger: 'blur' }
					],
					password: [
							{ required: true, message: '请输入密码', trigger: 'blur' }
					],
				}
			}
		},
		methods: {
			submitLogin() {
				
				 this.$refs.loginForm.validate((valid) => {
				  if (valid) {
					  this.postKeyValueRequest('/doLogin',this.LoginForm).then(resp=>{
						  if(resp){
							   
							  window.sessionStorage.setItem("user", JSON.stringify(resp.obj));
							  
							  this.$router.replace('/home' );
							  
						  }
					  })
					//alert('submit!');
				  } else {
					//console.log('请输入所有字段！');
					return false;
				  }
				});
			}
		}
	}
</script>

<style>
	.loginContainer{
		border-radius: 15px;
		background-clip: padding-box;
		margin: 180px auto;
		/* height: 240px; */
		width: 350px;
		padding: 15px 35px 15px 35px;
		background: #FFFFFF;
		border: 1px solid #eaeaea;
		box-shadow: 0 0 25px #cac6c6;
		font-family: 微软雅黑;
	}
	.loginTitle{
		margin: 15px auto 20px auto;
		text-align: center;
		color: #505458;
		font-family: 微软雅黑;
	}
	.loginRemember{
		text-align: left;
		margin:0px auto 10px auto;
		
	}
	
</style>
